<template>
  <el-dialog :visible.sync="showModal" :title="id ? '编辑分类' : '添加分类'">
    <el-form :model="form" :rules="rules" label-width="100px" ref="form">
      <el-form-item label="分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入分类名称,最多20个字" maxlength="20" />
      </el-form-item>
      <el-form-item label="排序号" prop="sortNum">
        <el-input v-model.number="form.sortNum" @input="form.sortNum = Number(form.sortNum) || ''" placeholder="排序号,数值越大越靠前" maxlength="10" />
      </el-form-item>
      <el-form-item label="所属项目" prop="projectId">
        <el-select v-model="form.projectId" style="width:100%" placeholder="请选择项目">
          <el-option :label="item.projectName" :value="item.id" v-for="(item,index) in projectData" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联班型" prop="courseType">
        <el-radio-group v-model="form.courseType">
          <el-radio :label="item.id" v-for="(item,index) in courseTypeList" :key="index">{{item.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分类描述" prop="classificationDescribe">
        <el-input v-model="form.classificationDescribe" placeholder="请输入分类描述,展示在前端分类名称下,最多20个字" maxlength="20" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { projectMoudel } from "../../mixins"
import { courseTypeList } from "../../dict"
import { projectPage, examClassificationAdd, examClassificationGet, examClassificationUpdate } from "../../api"
const rules = {
  name: [
    { required: true, message: '请输入分类名称', trigger: 'blur' },
  ],
  courseType: [
    { required: true, message: '请选择关联班型', trigger: 'change' },
  ],
  projectId: [
    { required: true, message: '请选择项目', trigger: 'change' },
  ]
}
export default {
  mixins: [projectMoudel],
  data () {
    return {
      courseTypeList,
      rules,
      showModal: false,
      form: {
        name: "",
        sortNum: null,
        projectId: null,
        courseType: 0,
        classificationDescribe: null
      },
      id: null,
    }
  },
  methods: {
    init (id) {
      this.showModal = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.getprojectPage()
        this.id = id
        if (this.id) {
          this.detail(id)
        }
      })
    },
    async detail (id) {
      const res = await examClassificationGet({ id })
      const data = res.data
      Object.keys(this.form).forEach(keys => {
        this.form[keys] = data[keys]
      })
    },
    submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const params = { ...this.form }
          if (this.id) {  //编辑
            params.id = this.id
            const res = await examClassificationUpdate(params)
            this.$message.success('更新成功！')
            this.showModal = false
            this.$emit('update', true)
          } else { //新增
            const res = await examClassificationAdd(params)
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('操作成功！')
            this.showModal = false
            this.$emit('update', true)
          }
        } else {
          return false;
        }
      });

    }
  }
}
</script>

<style>
</style>